import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const outlets = () => {
  return [
    {
      id: '1',
      globalOutletId: '1',
      name: 'OutLet One',
      status: 'ACTIVE',
      type: 'PRIMARY',
      searchHistory: ['Pathta', 'Pathati', 'Pathanti', 'prod'],
      mappedCompanies: [
        {
          status: 'ACTIVE',
          company: {
            id: '470041',
            name: 'Brand One',
            kyc: [],
            logoUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompop/12101_0551796aDEMO_products2_(1).png',
            setting: {
              loyaltyEnabled: true,
              showDeliveryDate: true,
              showPreTaxPrice: true,
            },
            currency: 'INR',
            currencyName: 'Saudi Riyal',
            supportPhoneNumber: '9064071869',
          },
          warehouses: [
            {
              id: '1',
              name: 'Cloud Dealers Pvt Ltd',
              address:
                'Sri Arunachaleshwara Building, Bellandur Main Rd, next to Sterling Suites, Adarsh Palm Retreat, Bellandur, Bengaluru, Karnataka 560103',
              phoneNo: '080 4110 8397',
              isPrimary: true,
            },
            {
              id: '2',
              name: 'Venkateshwara Sellers',
              address: '487, 4th B Cross Rd, Bellandur, Bengaluru, Karnataka',
              phoneNo: '',
              isPrimary: false,
            },
            {
              id: '3',
              name: 'Sellers Two',
              address: '',
              phoneNo: '',
              isPrimary: false,
            },
          ],
        },
        {
          status: 'ACTIVE',
          company: {
            id: '470042',
            name: 'Brand Two',
            kyc: [],
            logoUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompop/12101_e5d39ea5Demo2.png',
            setting: {
              loyaltyEnabled: false,
              showDeliveryDate: false,
              showPreTaxPrice: false,
            },
            currency: 'INR',
            currencyName: 'India Rupee',
            supportPhoneNumber: '9800473936',
          },
          warehouses: [],
        },
        {
          status: 'PENDING',
          company: {
            id: '470043',
            name: 'Brand Three',
            kyc: [],
            logoUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompop/12101_2e974fe7DEMO_products3.png',
            currency: 'INR',
            currencyName: 'India Rupee',
            supportPhoneNumber: '9800473936',
          },
          warehouses: [],
        },
      ],
      shopAddress: 'abc',
      locality: '',
      city: '',
      country: '',
      landmark: '',
      pincode: 0,
      state: '',
    },
  ];
};

const suggestedOutlets = ({ phoneno, dialCode, otp }) => {
  if (phoneno === '9876543210' && dialCode === '91' && !otp) {
    return [];
  } else {
    return [
      {
        globalId: '1234',
        latitude: 12.43,
        longitude: 13.43,
        name: 'Suggested Outlet',
        ownerMobile: '9999888821',
        phoneno: '9999888821',
        pincode: 0,
        shopAddress: 'Suggested address',
      },
    ];
  }
};

const handleAddOutlet = input => {
  return {
    city: input.city,
    closingTime: input.closingTime,
    country: input.country,
    globalOutletId: '1',
    id: '1',
    isOutletPhotoProvided: false,
    landmark: input.landmark,
    latitude: input.latitude,
    locality: input.locality,
    longitude: input.longitude,
    mappedCompanies: [],
    name: input.name,
    openingTime: input.openingTime,
    pincode: input.pincode,
    searchHistory: [],
    shopAddress: input.shopAddress,
    state: input.state,
    status: 'ACTIVE',
    type: 'PRIMARY',
  };
};

const handleOTPRequest = (dialCode, phoneno) => true;

const mocks = {
  Query: {
    outlets: _ => outlets(),
    getSuggestedOutletsByPhoneNumber: (_, input) => suggestedOutlets(input),
  },
  Mutation: {
    addOutlet: (_, { input }) => handleAddOutlet(input),
    otpForOutletOnboarding: (_, { dialCode, phoneno }) =>
      handleOTPRequest(dialCode, phoneno),
  },
};
export { resolvers, typeResolvers, mocks };
